import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, getDocs, query, where, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Form, Alert } from "react-bootstrap";
import "./AuthManager.css";


const AuthManager = ({ onUserAuthenticated }) => {
    const auth = getAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [role, setRole] = useState("user"); // Rol por defecto
    const [isRegistering, setIsRegistering] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(null);

    const handleAuth = async (e) => {
        e.preventDefault();
        try {
            if (isRegistering) {
                // Crear usuario en Firebase Authentication
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);

                // Guardar perfil del usuario en Firestore
                const userId = userCredential.user.uid;
                await setDoc(doc(db, "users", userId), {
                    uid: userId,
                    email,
                    name,
                    role,
                });

                // Crear colecciones únicas para el usuario, identificadas por su correo
                const userEmailId = email.replace(/[^a-zA-Z0-9]/g, "_"); // Reemplazar caracteres no permitidos en nombres
                const userCollections = ["nfcTags", "songs"]; // Nombres de las colecciones del usuario

                for (const collectionName of userCollections) {
                    await setDoc(doc(db, `${collectionName}_${userEmailId}`, "metadata"), {
                        owner: email,
                        data: [], // Estructura inicial vacía
                    });
                }

                setMessage("Registro exitoso. Ahora puedes iniciar sesión.");
            } else {
                // Inicio de sesión
                const userCredential = await signInWithEmailAndPassword(auth, email, password);

                // Obtener datos del usuario desde Firestore
                const userDoc = await getDocs(
                    query(collection(db, "users"), where("uid", "==", userCredential.user.uid))
                );
                if (!userDoc.empty) {
                    const userData = userDoc.docs[0].data();
                    onUserAuthenticated(userData); // Notifica al componente principal
                    setMessage("Inicio de sesión exitoso.");
                } else {
                    throw new Error("No se encontró el perfil del usuario.");
                }
            }
        } catch (err) {
            setError(err.message);
        }
    };

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            onUserAuthenticated(null);
            setMessage("Sesión cerrada exitosamente.");
        } catch (err) {
            setError("Error al cerrar sesión.");
        }
    };

    return (
        <div className="container mt-4">
            <h2>{isRegistering ? "Registrar Cuenta" : "Iniciar Sesión"}</h2>
            <Form onSubmit={handleAuth}>
                {isRegistering && (
                    <>
                        <Form.Group controlId="name">
                            <Form.Label>Nombre:</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingresa tu nombre"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="role" className="mt-3">
                            <Form.Label>Rol:</Form.Label>
                            <Form.Select value={role} onChange={(e) => setRole(e.target.value)} required>
                                <option value="user">Usuario</option>
                                <option value="admin">Administrador</option>
                            </Form.Select>
                        </Form.Group>
                    </>
                )}
                <Form.Group controlId="email" className="mt-3">
                    <Form.Label>Correo Electrónico:</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Ingresa tu correo"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="password" className="mt-3">
                    <Form.Label>Contraseña:</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Ingresa tu contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </Form.Group>
                <Button type="submit" variant="primary" className="mt-3">
                    {isRegistering ? "Registrar" : "Iniciar Sesión"}
                </Button>
                <Button
                    variant="link"
                    onClick={() => setIsRegistering(!isRegistering)}
                    className="mt-3"
                >
                    {isRegistering ? "¿Ya tienes cuenta? Inicia sesión" : "¿No tienes cuenta? Regístrate"}
                </Button>
            </Form>
            {message && <Alert variant="success" className="mt-3">{message}</Alert>}
            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {auth.currentUser && (
                <Button onClick={handleSignOut} variant="secondary" className="mt-3">
                    Cerrar Sesión
                </Button>
            )}
        </div>
    );
};

export default AuthManager;
